import React, { useState, useEffect, useRef } from 'react';
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import ImageComponents from '../../../../Shared/ImageComponents'
import UpiQR from './UpiQR';
import CustomizedDialogs from "../../../../Shared/CustomDialogs";
import UpiPaymentProcess from './UpiPaymentProcess';
import PaymentFailedPopup from './upiRetry';
import fetchTxnStatus from '../../Components/fetchTxnStatus';
import fetchQRTxnStatus from '../../Components/fetchQRTxnStatus';
import Loader from '../../Components/loader';
import getDomain from '../../Components/getDomain';
import fetchMandateStatus from '../../fetchMandateStatus';
import WhatIsEmandatePopup from '../ChildComponents/WhatIsEmandatePopup';
import RecurringAutodebitConsentFooter from '../RecurringAutodebitConsentFooter';
import IntentPaymentStatusDialog from './IntentPaymentStatusDialog';

function UpiDetailsRecurring({payMode, productId, txAmount, showEmanQrCode, showUpiEmandateIntent, isEligibleForUpiCollectEman, isParentOtmSuccess = false}) {
 console.log('productId'+productId);
  const [upiProviderId, setUPIProviderId] = React.useState(-1);
  const [showWhatisEmandatePopup, setShowWhatisEmandatePopup] = React.useState(false);
  const [upiHandleIndex, setUpiHandleIndex] = React.useState(0);
  const [subPayModes] = React.useState(payMode.subPayModes);
  const [isChecked, setIsChecked] = useState(true);
  const [showLoader, setshowLoader] = useState(false);
  const [vpa, setVpa] = useState('');
  const [vpaId, setVpaId] = useState('');
  const [mode,setMode] = useState('UPI_EMANDATE');
  const [validVPAerror, setvalidVPAerror] = useState('');
  const [payId, setPayId] = useState('');
  const [statusWaitTime , setWaitStatusTime] = useState('5');
  const [showUpiPopUp, setshowUpiPopUp] = useState(false);
  const [showRetry, setShowRetry] = useState(false);
  const [intermediateResponseData, setIntermediateResponseData] = useState(null);
  const [showUpiBarCode, setShowUpiBarCode] = useState(false);
  const [waitingForUpiStatus, setWaitingForUpiStatus] = useState(false);
  const waitingForUpiStatusRef = useRef(waitingForUpiStatus);
  const [txnurl , settxnurl ] = useState('');
  const [pgpayload , setpgpayload] = useState('');
  const [showForm, setShowForm] = useState(0);
  const [rupayMap , setRupayMap] = useState('');
  const [formHtml, setFormHtml] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 580);
  const [intentError, setIntentError] = useState('');
  const [showIntentStatusDialog, setShowIntentStatusDialog] = useState(false);
  const intentStatusDetailsRef = useRef(null);
  const intentPollingSessionRef = useRef(0);
  
  const [QrCodeData , setQrCodeData] = useState('');
  const [showUpiQR, setshowUpiQR] = useState(showEmanQrCode);
  const [isHealth , setIsHealth] = useState(false);
  const [isMotor , setIsMotor] = useState(false);
  const [isAppSwitched, setIsAppSwitched] = useState(false);
  const lastVisibilityStateRef = useRef(document.visibilityState);
  const isPollingRef = useRef(false);
  const isCheckingStatusRef = useRef(false);
  
  useEffect(() => {
   if (productId === 2 || productId === 147) {
    setIsHealth(true);
  }
  if (productId === 117 ) {
    setIsMotor(true);
  }
}, [productId]);

  useEffect(() => {
      waitingForUpiStatusRef.current = waitingForUpiStatus;
  }, [waitingForUpiStatus]);

  useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 580);
    };

    window.addEventListener('resize', handleResize);
    return () => {
        window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      console.log('App Switch Detection:', {
        previousState: lastVisibilityStateRef.current,
        newState: document.visibilityState,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });

      if (document.visibilityState === 'visible' && 
          lastVisibilityStateRef.current === 'hidden' && 
          isCheckingStatusRef.current) {
        console.log('Detected return from app switch');
        setIsAppSwitched(true);
        console.log('Resuming polling after app switch');
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      } else if (document.visibilityState === 'hidden') {
        isPollingRef.current = false;
      }

      lastVisibilityStateRef.current = document.visibilityState;
    };

    const handleFocus = () => {
      console.log('Window Focus:', {
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        isAppSwitched,
        timestamp: new Date().toISOString()
      });

      if (isAppSwitched && isCheckingStatusRef.current) {
        console.log('Resuming after app switch (focus)');
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
        setIsAppSwitched(false);
      }
    };

    const handleBlur = () => {
      console.log('Window Blur:', {
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });
      isPollingRef.current = false;
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, [isAppSwitched]);

  const domain = getDomain();
  const actionUrl = domain+`/pay/payment/razorpay/thankyou/emandate`;
  const defaultQrThankYouUrl = domain+`/pay/payment/paytm/qr/thankyou/emandate`;
  const getEmandateQrThankYouUrl = (gateway) => {
    const normalizedGateway = (gateway || '').toLowerCase();
console.log('getEmandateQrThankYouUrl -> gateway:', gateway, '| normalized:', normalizedGateway);

    if (normalizedGateway === 'razorpay') {
      return domain + `/pay/payment/razorpay/thankyou/emandate`;
    }else if (normalizedGateway === 'pbpay') {
      return domain + `/pay/payment/razorpay/thankyou/emandate`;
    }
    return defaultQrThankYouUrl;
  };
  const [qrThankYouUrl, setQrThankYouUrl] = useState(defaultQrThankYouUrl);
  let var1;
  let var2;
  let form;
  let eMandateNo;
  
  const handleClickonWhatisEmandate= ()=>{
    setShowWhatisEmandatePopup(true);
  }



  const handleCloseWhatisEmandate= ()=>{
    setShowWhatisEmandatePopup(false);
  }

  const handleUPIProviderChange = (upiHandlerId) => {
    setUPIProviderId(upiHandlerId);
  }

  const handleProviderDropDownChange = (event)  =>{
    handleUPIProviderChange(event.target.value);
  }

  const handleUpiHandlerIndexChange = (event) =>{
    setUpiHandleIndex(event.target.value);
  }

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked); 
    console.log("Checkbox is checked:", event.target.checked);
  };

  const handleVpaChange = (event) => {
    setVpa(event.target.value);
  };

   const handleIntentPayNow = async () => {
      setshowLoader(true);
      setIntentError('');
      const queryParameters = new URLSearchParams(window.location.search);
      const order = queryParameters.get("orderNo");
      var1 = queryParameters.get("var1");
      var2 = queryParameters.get("var2");
      const mode = "UPI_EMANDATE_INTENT";
      setMode('UPI_EMANDATE_INTENT');
      try {
        const response = await fetch('/pay/securePayment/process/intermediate/paymentui', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            orderNo: order,
            mode: mode,
          })
        });
        const data1 = await response.json();
        setQrThankYouUrl(getEmandateQrThankYouUrl(data1.upiGateway || data1.gateway));

        if (data1 && data1.decPayId && data1.intentLink) {
          setshowLoader(false);
          const decPayId = data1.decPayId;
          var1 = data1.interStatusVar1;
          var2 = data1.interStatusVar2;
          eMandateNo = data1.encryptedEMandateNo;
          setPayId(decPayId);
          const intentPollingSession = ++intentPollingSessionRef.current;
          intentStatusDetailsRef.current = { payId: decPayId, var1, var2, eMandateNo };
          isCheckingStatusRef.current = true;
          setWaitingForUpiStatus(true);
          waitingForUpiStatusRef.current = true;
          setShowIntentStatusDialog(true);
          window.location.href = data1.intentLink;
          const waitTime = (data1.upiWaitStatusTime || 5);
          const gateway = data1.upiGateway || data1.gateway;
          if (gateway === 'razorpay' || gateway === 'pbpay') {
            setTimeout(() => checkTransactionStatus(decPayId, var1, var2, eMandateNo, intentPollingSession), waitTime * 1000);
          } else {
            setTimeout(() => checkQRTransactionStatus(decPayId, var1, var2, eMandateNo, intentPollingSession), waitTime * 1000);
          }
        } else {
          setshowLoader(false);
          setIntentError('Unable to initiate UPI intent. Please try again.');
        }
      } catch (error) {
        console.error('Error:', error);
        setshowLoader(false);
        setIntentError('Unable to initiate UPI intent. Please try again.');
      }
    };


  const callIntermediate = async (orderNo, mode, decodedVPA, gatewayName)=>{
    const response1 = await fetch('/pay/securePayment/process/intermediate/paymentui', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            orderNo: orderNo,
            mode: mode,
            vpa: decodedVPA,
            gateway: gatewayName
        })
    });

    const data1 = await response1.json();
    setIntermediateResponseData(data1);
    let decPayId;
    var1 = data1.interStatusVar1;
    var2 = data1.interStatusVar2;

    
    setshowLoader(false);

    if(gatewayName == 'razorpay' ||  gatewayName == 'payu' || gatewayName == 'pbpay'){
      setPayId(data1.decPayId);
      decPayId = data1.decPayId;
      eMandateNo = data1.encryptedEMandateNo;
    } else if(gatewayName == 'pbpay'){
      setPayId(data1.decPayId);
      decPayId = data1.decPayId;
      eMandateNo = data1.encryptedEMandateNo;
    }

    if (data1.ishtml && data1.form) {
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = data1.form;
      const formElement = tempContainer.querySelector('form');
      if (formElement) {
        document.body.appendChild(formElement);
        formElement.submit();
        return;
      }
    } else if (data1.decPayId) {
        setWaitingForUpiStatus(true);
        setWaitStatusTime(data1.upiWaitStatusTime);
        setshowUpiPopUp(true);
        console.log('statusWaitTime' + statusWaitTime);
        setTimeout(() => checkTransactionStatus(decPayId, var1, var2, eMandateNo), data1.upiWaitStatusTime * 1000);
    } else{
        setshowLoader(false);
        setvalidVPAerror('Some error occured, Please try again!');
    }
  }

  const getGatewayNameResponse = async (decodedOrder, productId) => {
    const response = await fetch('/pay/payment/vpaValidation/gateway', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            orderNo: decodedOrder,
            productId: productId,
        })
    });
    return await response.json();
  }

  const getVerifyGatewayResponse = async (decodedOrder, vpaId, gatewayName, isEncrypted)=>{
    const params = new URLSearchParams({
      vpa: vpaId,
      gateway: gatewayName,
      orderNo: decodedOrder,
      isEncrypted: isEncrypted
    });
    const url = `/pay/eMandate/vpaVerify?${params.toString()}`;
    const responseGateWayValidation = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return await responseGateWayValidation.json();
  }

  const getHdfcEmanStatuResponse = async (eMandateNo, orderId, payId)=>{
    const params = new URLSearchParams({
      eMandateNo: eMandateNo,
      orgPspRefNo: orderId,
      payId: payId
    });
    const url = `/pay/eMandate/hdfc/emanStatus?${params.toString()}`;
    const responseGateWayValidation = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return await responseGateWayValidation.json();
  }


  const getVerifyGatewayResponsePaytm = async (decodedOrder, productId, vpaId, txAmount)=>{
    const responseValidation = await fetch('pay/payment/verifyVpa/paytm', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            orderNo: decodedOrder,
            productId: productId,
            vpa: vpaId,
            amountToBePaid: txAmount
        })
    });
    return await responseValidation.json();
  }



  const handlePayNow = async () => {
    if (vpa != '') {
        setshowLoader(true);
        const queryParameters = new URLSearchParams(window.location.search);
        const order = queryParameters.get("orderNo");
        const decodedOrder = decodeURIComponent(order);
        var1 = queryParameters.get("var1");
        var2 = queryParameters.get("var2");
        
        const vpaId = vpa + subPayModes[upiProviderId].upiHandles[upiHandleIndex];
        setVpaId(vpaId);
        const decodedVpa = decodeURIComponent(vpaId);
        
        try {
            const gatewayData = await getGatewayNameResponse(decodedOrder, productId);
            const gatewayName = gatewayData.vpavalidationGateway;
            if(gatewayName != 'paytm'){
              // url: "/pay/eMandate/vpaVerify?vpa=" + vpa + "&gateway=" + vpaValidationGateway + "&orderNo=" + displayOrderNo,
              
              const validationData =  await getVerifyGatewayResponse(decodedOrder, vpaId, gatewayName, true);
              if(validationData.valid){
                console.log('gateway validated');
                callIntermediate(order,'UPI_EMANDATE',decodedVpa, gatewayName);
              }else{
                setshowLoader(false);
                setvalidVPAerror('Please enter a valid UPI ID');
              }
            }else{
              const validationData = await getVerifyGatewayResponsePaytm(decodedOrder, productId, vpaId, txAmount);
              if(validationData.data.isValid){
                submitDetailsPaytm(decodedOrder, mode, encodeURIComponent(vpaId), gatewayName);
              }else{
                setshowLoader(false);
                setvalidVPAerror('Please enter a valid UPI ID');
              }
            }
        } catch (error){
          setshowLoader(false);
          console.log(error);
        }
    } else {
      setvalidVPAerror('Please enter a valid UPI ID');
    }
  };

  const checkTransactionStatus = async (payId, var1, var2, eMandateNo, intentPollingSession = null) => {
    if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
      return;
    }

    let retries = 0;
    const maxRetries = 60;
    isPollingRef.current = true;

    const handleVisibilityChange = () => {
      console.log('Transaction Status - Visibility Change:', {
        previousState: lastVisibilityStateRef.current,
        newState: document.visibilityState,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });

      if (document.visibilityState === 'visible' && 
          lastVisibilityStateRef.current === 'hidden' && 
          isCheckingStatusRef.current) {
        console.log('Resuming polling after app switch');
        retries = 0;
        setShowRetry(false);
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      } else if (document.visibilityState === 'hidden') {
        isPollingRef.current = false;
      }
      
      lastVisibilityStateRef.current = document.visibilityState;
    };

    const handlePageShow = (event) => {
      console.log('Transaction Status - Page Show:', {
        fromCache: event.persisted,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });
      if (isCheckingStatusRef.current) {
        retries = 0;
        setShowRetry(false);
        isCheckingStatusRef.current = true;
        isPollingRef.current = true;
      }
    };

    const handlePageHide = (event) => {
      console.log('Transaction Status - Page Hide:', {
        toCache: event.persisted,
        isCheckingStatus: isCheckingStatusRef.current,
        isPolling: isPollingRef.current,
        timestamp: new Date().toISOString()
      });
      isPollingRef.current = false;
    };

    const cleanup = () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);
      isPollingRef.current = false;
      isCheckingStatusRef.current = false;
    };

    try {
      let txnStatus = '';
      console.log('Adding transaction status event listeners...');
      
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('pageshow', handlePageShow);
      window.addEventListener('pagehide', handlePageHide);
      
      console.log('Transaction status event listeners added');
      console.log('Current visibility state:', document.visibilityState);
      console.log('isCheckingStatus:', isCheckingStatusRef.current);
      console.log('isPolling:', isPollingRef.current);

      while (
        isCheckingStatusRef.current &&
        (intentPollingSession === null || intentPollingSession === intentPollingSessionRef.current) &&
        retries < maxRetries
      ) {
        if (!isPollingRef.current) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          continue;
        }
        retries++;
        const encodedPayId = encodeURIComponent(payId);
        const response = await fetchTxnStatus(encodedPayId, var1, var2);
        if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
          break;
        }
        if(response === null) {
          continue;
        }
        txnStatus = response.status;
        
        if (txnStatus === 'TXN_SUCCESS') {
          cleanup();
          checkMandateStatus(eMandateNo, var1, var2, payId);
          break;
        }
        else if(txnStatus === 'TXN_FAILURE') {
          cleanup();
          setShowUpiBarCode(false);
          setshowUpiPopUp(false);
          setShowIntentStatusDialog(false);
          setshowLoader(false);
          setShowRetry(true);
          break;
        }
        
        await new Promise(resolve => setTimeout(resolve, 5000));
      }

      if (!isCheckingStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
        cleanup();
        return;
      }

      if (retries >= maxRetries) {
        cleanup();
        setShowUpiBarCode(false);
        setshowUpiPopUp(false);
        setShowIntentStatusDialog(false);
        setshowLoader(false);
        setShowRetry(true);
      }
    } catch (error) {
      console.log("Error in checkTransactionStatus:", error);
    }
  };  

  const checkMandateStatus= async (eMandateNo, var1, var2, payId)=>{
    try {

      let mandateStatus = '';
      const maxRetries=4;
      let retries=0;
      const encodedPayId = encodeURIComponent(payId);
      const queryParameters = new URLSearchParams(window.location.search);
      const order = queryParameters.get("orderNo");
      const encodedOrderNo=encodeURIComponent(order);
      while (waitingForUpiStatusRef.current && retries<maxRetries) {
          console.log('check mandate status....');
          retries++;
          const response = await fetchMandateStatus(var1, encodedOrderNo, encodedPayId);
          if(response===null){
            continue;
          }
          mandateStatus = response.status;
          if (mandateStatus === 'TXN_SUCCESS' || mandateStatus === 'TXN_FAILURE') {
            submitFormWithPayId(payId, var1, var2, eMandateNo);
            break;
          }     
          await new Promise(resolve => setTimeout(resolve, 5000));
        }
        if(retries>=maxRetries){
          submitFormWithPayId(payId, var1, var2, eMandateNo);
        }
  } catch (error) {
      console.error('Error checking mandate status:', error);
  }
}


const checkMandateStatusQR= async (eMandateNo, var1,var2, payId)=>{
  try {
    let mandateStatus = '';
    const maxRetries=4;
    let retries=0;
    const encodedPayId=encodeURIComponent(payId);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    const encodedOrderNo=encodeURIComponent(order);
    while (waitingForUpiStatusRef.current && retries<maxRetries) {
        console.log('check mandate status....');
        retries++;
        const response = await fetchMandateStatus(var1, encodedOrderNo, encodedPayId);
        if(response===null){
          continue;
        }
        mandateStatus = response.status;
        if (mandateStatus === 'TXN_SUCCESS' || mandateStatus === 'TXN_FAILURE') {
          submitFormWithQR(payId, var1, var2, eMandateNo);
          break;
        }     
        await new Promise(resolve => setTimeout(resolve, 5000));
      }
      if(retries>=maxRetries){
        submitFormWithQR(payId, var1, var2, eMandateNo);
      }
} catch (error) {
    console.error('Error checking mandate status:', error);
}
}
  
  
    const checkQRTransactionStatus = async (payId, var1, var2, eMandateNo, intentPollingSession = null) => {
    if (!waitingForUpiStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
      return;
    }

    let retries = 0;
    const maxRetries = 60;
    let isPolling = true;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && waitingForUpiStatusRef.current) {
        retries = 0;
        setShowRetry(false);
        waitingForUpiStatusRef.current = true;
        isPolling = true;
      } else if (document.visibilityState === 'hidden') {
        isPolling = false;
      }
    };

    const handlePageShow = () => {
      console.log('Page Show event triggered');
      if (waitingForUpiStatusRef.current) {
        retries = 0;
        setShowRetry(false);
        waitingForUpiStatusRef.current = true;
        isPolling = true;
      }
    };

    const handlePageHide = () => {
      console.log('Page Hide event triggered');
      isPolling = false;
    };

    const cleanup = () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);
    };

    try {
      let txnStatus = '';
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('pageshow', handlePageShow);
      window.addEventListener('pagehide', handlePageHide);

      while (
        waitingForUpiStatusRef.current &&
        (intentPollingSession === null || intentPollingSession === intentPollingSessionRef.current) &&
        retries < maxRetries
      ) {
        if (!isPolling) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          continue;
        }
        retries++;
        const encodedPayId = encodeURIComponent(payId);
        const response = await fetchQRTxnStatus(encodedPayId, var1, var2);
        if (!waitingForUpiStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
          break;
        }
        if(response === null) {
          continue;
        }
        txnStatus = response.status;
        
        if (txnStatus === 'TXN_SUCCESS') {
          cleanup();
          checkMandateStatusQR(eMandateNo, var1, var2, payId);
          break;
        }
        else if(txnStatus === 'TXN_FAILURE') {
          cleanup();
          setShowUpiBarCode(false);
          setshowUpiPopUp(false);
          setShowIntentStatusDialog(false);
          setshowLoader(false);
          setShowRetry(true);
          waitingForUpiStatusRef.current = false;
          break;
        }
        
        await new Promise(resolve => setTimeout(resolve, 5000));
      }

      if (!waitingForUpiStatusRef.current || (intentPollingSession !== null && intentPollingSession !== intentPollingSessionRef.current)) {
        cleanup();
        return;
      }

      if (retries >= maxRetries) {
        cleanup();
        setShowUpiBarCode(false);
        setshowUpiPopUp(false);
        setShowIntentStatusDialog(false);
        setshowLoader(false);
        setShowRetry(true);
        waitingForUpiStatusRef.current = false;
      }
    } catch (error) {
      console.log("Error in checkQRTransactionStatus:", error);
    }
  };

	
  const submitDetailsPaytm =  async (orderNo, mode, vpa, gateway) =>{
    const payload = {
        orderNo,
        mode,
        vpa,
        gateway
    };
    const response = await fetch('/pay/securePayment/process/paymentui', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const data = await response.json();
    setshowLoader(false);
    if (data.as === 1) {

        if (data.pgPayload.form) {
            const formHtml = data.pgPayload.form;
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = formHtml;

            const formElement = tempContainer.querySelector('form');
            document.body.appendChild(formElement);
            formElement.submit();
        } else if (data.txnURL) {
            settxnurl(data.txnURL);
            setpgpayload(data.pgPayload);
            await delay(1500);
            form = document.getElementById('testForm');
            form.submit();

        }


    } else if (data.as === 2) {
        window.location.href = data.txnURL1;

    } else if (data.as === 3) {
        if (data.mastRupay) {
            setShowForm(2);
            setRupayMap(data.mastRupay);
        } else {
            setFormHtml(data.form);
            setShowForm(data.showForm);
            await delay(1500);
        }

    } else if (data.error === 1) {
        window.location.reload();
    }
    
  }

  const submitFormWithPayId = (payId, var1, var2, eMandateNo) => {
    const form = document.getElementById('submitUpi');
    const payIdInput = form.querySelector('input[name="payId"]');
    const var1Input = form.querySelector('input[name="var1"]');
    const var2Input = form.querySelector('input[name="var2"]');
    const eMandateNoInput = form.querySelector('input[name="eMandateNo"]');

    payIdInput.value = payId;
    var1Input.value = var1;
    var2Input.value = var2;
    eMandateNoInput.value = eMandateNo;
    
    form.submit();
  };
  
  
  const submitFormWithQR = (payId, var1, var2 , eMandateNo) => {
    const form = document.getElementById('submitQR');
    const payIdInput = form.querySelector('input[name="payId"]');
    const var1Input = form.querySelector('input[name="var1"]');
    const var2Input = form.querySelector('input[name="var2"]');
    const eMandateNoInput = form.querySelector('input[name="eMandateNo"]'); 

    payIdInput.value = payId;
    var1Input.value = var1;
    var2Input.value = var2;
    eMandateNoInput.value = eMandateNo;
    
    
    form.submit();
  };

  const handleCloseDialog = () => {
    ++intentPollingSessionRef.current;
    isCheckingStatusRef.current = false;
    isPollingRef.current = false;
    waitingForUpiStatusRef.current = false;
    setShowIntentStatusDialog(false);
    setShowUpiBarCode(false);
    setWaitingForUpiStatus(false);
    setshowUpiPopUp(false);
    setShowRetry(false);
  };

  const cancelIntentPayment = async () => {
    const cancellationStartedAt = Date.now();
    const intentStatusDetails = intentStatusDetailsRef.current;
    const keepCancellationFeedbackVisible = async () => {
      const remainingTime = Math.max(0, 2000 - (Date.now() - cancellationStartedAt));
      if (remainingTime) await new Promise(resolve => setTimeout(resolve, remainingTime));
    };

    ++intentPollingSessionRef.current;
    isCheckingStatusRef.current = false;
    isPollingRef.current = false;
    waitingForUpiStatusRef.current = false;
    setWaitingForUpiStatus(false);

    try {
      if (intentStatusDetails) {
        const response = await fetchTxnStatus(
          encodeURIComponent(intentStatusDetails.payId),
          intentStatusDetails.var1,
          intentStatusDetails.var2
        );
        if (response?.status === 'TXN_SUCCESS') {
          await keepCancellationFeedbackVisible();
          setShowIntentStatusDialog(false);
          waitingForUpiStatusRef.current = true;
          setWaitingForUpiStatus(true);
          checkMandateStatus(
            intentStatusDetails.eMandateNo,
            intentStatusDetails.var1,
            intentStatusDetails.var2,
            intentStatusDetails.payId
          );
          return;
        }
      }
    } catch (error) {
      console.log('Final UPI E-Mandate Intent status check failed:', error);
    }

    await keepCancellationFeedbackVisible();
    setshowLoader(false);
    setShowIntentStatusDialog(false);
  };


  const retryPayment = async () => {
     setShowRetry(false);
     if (mode === 'UPI_EMANDATE_INTENT') {
       handleIntentPayNow();
     } else {
       handlePayNow();
     }
  };

  const delay = millis => new Promise((resolve, reject) => {
    setTimeout(_ => resolve(), millis)
  });

  const handleQRPayNow = async () => {
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    var1 = queryParameters.get("var1");
    var2 = queryParameters.get("var2");
    const mode = "UPI_EMANDATE_QR";
    setMode('UPI_EMANDATE_QR');
    try {
      const response = await fetch('/pay/securePayment/process/intermediate/paymentui', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNo: order,
          mode: mode,
        })
      });
      const data = await response.json();
      console.log(data);
      if(data && data.decQrPayId){
       
        setQrCodeData(data);
        setQrThankYouUrl(getEmandateQrThankYouUrl(data.qrCodeGateway || data.gateway));
        setshowLoader(false);
        setShowUpiBarCode(true);
        setWaitingForUpiStatus(true);
        setWaitStatusTime(data.qrCodeWaitStatusTime);
        const decPayId = data.decQrPayId;
        eMandateNo = data.encryptedEMandateNo;
        var1 = data.interStatusVar1;
        var2 = data.interStatusVar2;
        setPayId(decPayId);
        console.log('statusWaitTime'+statusWaitTime);

       setTimeout(() => checkQRTransactionStatus(decPayId, var1, var2, eMandateNo), data.qrCodeWaitStatusTime * 1000);
          
      } else {
        setshowLoader(false);
        // handle error
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleVpaInputClick = () => {
     setvalidVPAerror('');
    };

  return (
      <>
      {showLoader && !showIntentStatusDialog && <Loader show={true} textToShow="Please wait while your transaction is being processed"/>}
      
      {pgpayload && (
        <form method="post" action={txnurl} id="testForm">
            {Object.keys(pgpayload).map((key, index) => (
                <input key={index} type="hidden" id={key} name={key} value={pgpayload[key]} />
            ))}
        </form>
      )}

      <form
        className="form-field"
        action={actionUrl}
        method="post"
        id="submitUpi"
        autoComplete="off"
      >
        <input type="hidden" name="payId" id="payId" />
        <input type="hidden" name = "eMandateNo" id="eMandateNo"/>
        <input type="hidden" name="var1" id="var1" value={var1} />
        <input type="hidden" name="var2" id="var2" value={var2} />
      </form>
      
      
        <form
        className="form-field"
        action={qrThankYouUrl}
        method="post"
        id="submitQR"
        autoComplete="off"
      >
      	 
        <input type="hidden" name="payId" id="payId" />
        <input type="hidden" name = "eMandateNo" id="eMandateNo"/>
        <input type="hidden" name="var1" id="var1" value={var1} />
        <input type="hidden" name="var2" id="var2" value={var2} />
      </form>
      

    <div className='upi-emandate-box'>
    {showUpiEmandateIntent && (
      <>
        <div className='card-details bg-white px-7 py-5'>
          <div className='card-detail-form'>
            <div className='emandate-heading'>
              <h4> Pay &amp; Register Autopay using an App </h4>
              <div className='sm:py-10 pe-3 ps-0 sm:mt-3' style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>
                <Button className="pay-now-btn" fullWidth style={{ width: '100%' }} onClick={() => handleIntentPayNow()}>
                  CHOOSE AN APP
                </Button>
              </div>
              {intentError ? (
                <div style={{ color: '#b00020', marginTop: '-7px' }}>{intentError}</div>
              ) : null}
            </div>
          </div>
        </div>
      </>
    )}

     {showUpiQR && !isMobile && (
        <>
          <li>
            <div class="upi-head1 clearfix1">
              <div class="left upi-gateway-warpper ">
                Pay &amp; Register Autopay using QR Code
                <p class="small-text">Click to view &amp; scan the QR code
                  with your prefered UPI app</p>
              </div>
            </div>
           <div class="qrCodeWrapper" id="EmanQrCodeBtn" 
            style={{width: '100%',height:'229px',background: 'url(images/qr-wrapper.svg) no-repeat center', cursor: 'pointer'}}
            onClick={() => handleQRPayNow()}
           ></div>
          </li>
        </>
      )}
      {isEligibleForUpiCollectEman && (
        <>
          <div className='emandate-heading'>
            <h4>Pay & Register Autopay using UPI ID</h4>
            <span className='whatIsEmandate-link' onClick={() => handleClickonWhatisEmandate()}>what is e-Mandate <em>?</em></span>
          </div>
          {upiProviderId == -1 && (
            <ul className='upi-emandate-list'>
              {subPayModes.map((mode, index)=>(
                <li>
                  <div className='g-pay'
                    onClick={() => handleUPIProviderChange(index)}
                  >
                    {isMobile && <div className='img-container'><ImageComponents className={mode.code} name={mode.code} /> </div>}
                    {!isMobile && <ImageComponents className={mode.code} name={mode.code} /> }{mode.name}
                  </div>
                </li>
              ))}
            </ul>
          )}

          {upiProviderId!=-1 && (
            <div className='upi-pay'>
              <div className='gpay-payment'>
                <p class="upi-provider-inner">
                  <ImageComponents className={subPayModes[upiProviderId].name} name={subPayModes[upiProviderId].name} /> {subPayModes[upiProviderId].name}
                </p>

                <FormControl fullWidth className="dropdown-upi-provider">
                  <InputLabel id="demo-simple-select-label">change</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={upiProviderId}
                    label="upiProvider"
                    onChange={handleProviderDropDownChange}
                  >
                    {subPayModes.map((mode, index)=>(
                      <MenuItem value={index}>{mode.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className='gpay-payment no-bg'>

                <TextField 
                  id="vpa-input"
                  label="Enter your UPI id"
                  value={vpa}
                  error={!!validVPAerror}
                  helperText={validVPAerror}
                  onChange={handleVpaChange}
                  onClick={handleVpaInputClick}
                  variant="outlined"
                />


                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Handle</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={upiHandleIndex}
                    label="upi"
                    onChange={handleUpiHandlerIndexChange}
                  >
                    {subPayModes[upiProviderId].upiHandles.map((handle, index)=>(
                      <MenuItem value={index}>{handle}</MenuItem>
                    ))}
                  </Select>
                </FormControl>


              </div>
              <FormGroup>
                <FormControlLabel
                  value="end"
                  control={<Checkbox id="autopayChecked" 
                    defaultChecked 
                    onChange={handleCheckboxChange} 
                  />} 
                  label="Securely Save this UPI account for a faster checkout next time"
                  labelPlacement="end"
                  onChange={handleCheckboxChange}
                />
              </FormGroup>
              <Button variant="outlined" size="large" className='pay-upi-btn' onClick={handlePayNow}>
                Pay & Register Autopay
              </Button>

            </div>

          )}
        </>
      )}

      {showUpiQR && isMobile && (
        <>
          <li>
            <div class="upi-head1 clearfix1">
              <div class="left upi-gateway-warpper ">
                Pay &amp; Register Autopay using QR Code
                <p class="small-text">Click to view &amp; scan the QR code
                  with your prefered UPI app</p>
              </div>
            </div>
           <div class="qrCodeWrapper" id="EmanQrCodeBtn" 
            style={{width: '100%',height:'229px',background: 'url(images/qr-wrapper.svg) no-repeat center', cursor: 'pointer'}}
            onClick={() => handleQRPayNow()}
           ></div>
          </li>
        </>
      )} 


      <div className='note-box'>
        <strong>Note</strong>: After successful registration, autopay will be enabled. Future payments on this account will be charged automatically.
      </div>
      {isParentOtmSuccess ? <RecurringAutodebitConsentFooter /> : null}
      {!isHealth && !isMotor && <div className='disclaimer'>
        <strong>Disclaimer</strong>: Amount authorised under e-mandate registration is Rs 2 higher than your premium amount. This is for registration purpose only, the amount deducted from your 	account will be the actual premium amount.
      </div>}
      {isHealth &&   <div className='disclaimer'>
        <strong>Disclaimer</strong>:  Amount authorised under e-mandate registration is 2.1 times of your transaction amount. This is for registration purpose only, the amount deducted from your account will be the actual installment amount.
      </div>}
      {isMotor &&   <div className='disclaimer'>
        <strong>Disclaimer</strong>:  Amount authorised under e-mandate registration is up to 1.4 times of your premium amount.This is for registration purposes only, the amount deducted from your account will be the actual premium amount
      </div>}

      {showWhatisEmandatePopup ?
      <CustomizedDialogs className="dialog-inner-box" open={showWhatisEmandatePopup} handleClose={() => setShowWhatisEmandatePopup(false)}>
        <WhatIsEmandatePopup onClose = {handleCloseWhatisEmandate} handleClose={() => setShowWhatisEmandatePopup(false)}/>
      </CustomizedDialogs> : null}
    </div>
    <Dialog  
      open={showUpiPopUp} 
      disableEscapeKeyDown 
      disablePortal
      disableAutoFocus
      BackdropProps={{
        onClick: (e) => e.stopPropagation()
      }}
    >
      <UpiPaymentProcess QrCodeData = {intermediateResponseData} handleCloseDialog={handleCloseDialog}  vpa={vpa} />
    </Dialog>

    <Dialog 
      open={showUpiBarCode} 
      disableEscapeKeyDown 
      disablePortal
      disableAutoFocus
      BackdropProps={{
        onClick: (e) => e.stopPropagation()
      }}
      className='upi-dialog'
    >
      <UpiQR  QrCodeData={QrCodeData} handleCloseDialog={handleCloseDialog} txAmount = {txAmount} mode = {mode}/>
    </Dialog>

    <IntentPaymentStatusDialog
      open={showIntentStatusDialog}
      title="Complete your payment. We'll confirm it automatically once it's successfull."
      onCancelPayment={cancelIntentPayment}
    />

    <Dialog 
      open={showRetry} 
      disableEscapeKeyDown 
      disablePortal
      disableAutoFocus
      BackdropProps={{
        onClick: (e) => e.stopPropagation()
      }}
    >
      <PaymentFailedPopup  handleCloseDialog={handleCloseDialog} retryPayment={retryPayment}  />
    </Dialog>
    </>
  )
}

export default UpiDetailsRecurring;
